"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _urlJoin = _interopRequireDefault(require("url-join"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Prepends a root to the url if a 'root' option is provided
function addRootToUrl(_ref) {
  var root = _ref.root,
      url = _ref.url;
  if (!root) return;
  return {
    url: (0, _urlJoin["default"])(root, url)
  };
}

var _default = addRootToUrl;
exports["default"] = _default;